import { Content } from '@elizaos/core';

export interface AccountInfoContent extends Content {
  address?: string;
  ens?: string;
  basename?: string;
  farcasterUsername?: string;
  fid?: number;
}

export interface AccountInfoData {
  address: string;
  displayName: {
    value: string;
    source: AccountDisplayNameSource;
  };
  avatar: {
    value: string;
    source: AccountAvatarSource;
  };
  description?: {
    value: string;
    source: AccountDescriptionSource;
  };
  socialLinks: AccountSocialLink[];
  ensRecord?: {
    name: string;
    metadata: {
      name: string;
      description?: string;
      avatar?: string;
      github?: string;
      twitter?: string;
      email?: string;
      website?: string;
    };
  };
  basename?: string;
  lensProfile?: {
    username: string;
    displayName?: string;
    bio?: string;
    avatar?: string;
  };
  farcasterProfile?: {
    username: string;
    fid: number;
    custodyAddress: string;
    connectedAddresses: string[];
    metadata: {
      displayName?: string;
      description?: string;
      imageUrl?: string;
      warpcast?: string;
      xAccount?: {
        username: string;
        url: string;
      };
    };
    followStats?: {
      followerCount: number;
      followingCount: number;
    };
  };
  followStats?: {
    followerCount: number;
    followingCount: number;
  };
  badges?: AccountBadge[];
  isContract: boolean;
  contract?: {
    name?: string;
    symbol?: string;
    decimals?: number;
  };
}

export interface AccountSocialLink {
  url: string;
  name: AccountSocialLinkName;
  source: AccountSocialLinkSource;
}

export interface AccountBadge {
  tokenId: number;
  badgeName: string;
  claimed: boolean;
  badgeNetwork: string;
}

export enum AccountDisplayNameSource {
  ENS = 'ENS',
  BASENAME = 'BASENAME',
  LENS = 'LENS',
  FARCASTER = 'FARCASTER',
  LABEL = 'LABEL',
  ADDRESS = 'ADDRESS',
}

export enum AccountDescriptionSource {
  ENS = 'ENS',
  LENS = 'LENS',
  FARCASTER = 'FARCASTER',
}

export enum AccountSocialLinkName {
  WEBSITE = 'WEBSITE',
  TWITTER = 'TWITTER',
  GITHUB = 'GITHUB',
  EMAIL = 'EMAIL',
  HEY = 'HEY',
  WARPCAST = 'WARPCAST',
}

export enum AccountSocialLinkSource {
  ENS = 'ENS',
  LENS = 'LENS',
  FARCASTER = 'FARCASTER',
}

export enum AccountAvatarSource {
  ZAPPER = 'ZAPPER',
  ENS = 'ENS',
  LENS = 'LENS',
  FARCASTER = 'FARCASTER',
  OPEPENS = 'OPEPENS',
  BLOCKIES = 'BLOCKIES',
}

export interface AccountInfoResponse {
  data: {
    accounts: AccountInfoData[];
  };
}

export interface FarcasterProfileData {
  username: string;
  fid: number;
  custodyAddress: string;
  connectedAddresses: string[];
  metadata: {
    displayName?: string;
    description?: string;
    imageUrl?: string;
    warpcast?: string;
    xAccount?: {
      username: string;
      url: string;
    };
  };
  followStats?: {
    followerCount: number;
    followingCount: number;
  };
}

export interface FarcasterProfileResponse {
  data: {
    farcasterProfile: FarcasterProfileData;
  };
}

export interface AccountResolutionResult {
  address: string;
  ens?: string;
  basename?: string;
  farcasterUsername?: string;
  fid?: number;
  displayName: string;
  avatar?: string;
  description?: string;
  socialLinks: AccountSocialLink[];
  followStats?: {
    followerCount: number;
    followingCount: number;
  };
  isContract: boolean;
  badges?: AccountBadge[];
}
